<template>
  <div>
    <span>
      <button
        v-on:click="cariEkstre()"
        style="border: none; background: none; margin-right: 5px"
      >
        <box-icon
          style="float: right"
          name="search-alt-2"
          animation="tada-hover"
          color="#7367F0"
          class="text-body align-middle mr-25"
        ></box-icon>
      </button>
    </span>
    <CariEkstreComponent ref="cariekstreref" />
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import "boxicons";

import CariEkstreComponent from "./CariEkstreComponent.vue";
import router from "../../../../router";

import { BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
  components: {
    CariEkstreComponent,
    BDropdown,
    BDropdownItem,
  },
  methods: {
    cariEkstre() {
      //  alert(ACTID);

      var ACTID = this.params.data.CARIKART_CARIID;
      var ACTNAME = this.params.data.CARIKART_CARIADI;

      this.$refs.cariekstreref.cariEkstre(ACTID, ACTNAME);
    },
  },
};
</script>